export function formatPlural(amount, strings) {
    var _a;
    if (amount === 0) {
        return (_a = strings.zero) !== null && _a !== void 0 ? _a : strings.multiple;
    }
    return amount === 1 ? strings.one : strings.multiple;
}
